export default "__VITE_ASSET__D74WXq88__"